import styled from "@emotion/styled";


export const Option = styled.div`
  padding-top: 0.4rem;
  padding-bottom: 0.4rem;

  span {
    margin-right: 10px;
  }
`

export const OptionList = styled.div`
  font-size: 14px;
`